export { default as getAlt } from './get-alt';
export { default as getAria } from './get-aria';
export { default as getIcon } from './get-icon';
export { default as getContactHref } from './get-contact-href';
